var gwp = window.gwp

$.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
        let items = cart.items;
        let counter = 0;
        let additional = [];

        items.forEach((item) => {
            if (item.product_id == '6701166788644') {
                counter++;

                additional.push(item);
            }
        });

        if (counter > 1) {
            console.log(additional[0].id);

            $.ajax({
                type: "POST",
                url: '/cart/update.js',
                dataType: 'json',
                data: {
                    updates: {
                        [additional[0].id]: 0
                    }
                }
            });
        }
    }
});

function initAjaxCart() {
    $(".cart__items-wrap").empty()


    jQuery.getJSON('/cart.js', function (cart) {
        // check for empty cart
        if (cart.item_count > 0) {
            $('.empty__cart').addClass('hidden')
            $('.cart__not-empty').removeClass('hidden')
        } else {
            $('.empty__cart').removeClass('hidden')
            $('.cart__not-empty').addClass('hidden')
        }

        cart.items.forEach(item => {
            console.log(item)
            if (item.handle == gwp.handle) {
                removeItem(item.variant_id).then(initGwp(cart))
            } else {
                $(".cart__items-wrap").append(renderCartElem(item))
            }
        });

        if($('.cart__row.item-child').length) {
            $('.cart__row.item-child').each(function() {
                let dataChild = $(this).attr('data-child');
                let parentId = dataChild.split('-')[0];
                $(`.cart__row.cart__row-${parentId}`).addClass('item-parent');
                $(`.cart__row.cart__row-${parentId}`).attr('data-child', `${dataChild}`);
            });
        }

        initGwp(cart);

        if ($('.cart__gwp-item').length > 1) {
            $('.cart__gwp-item').last().css('display', 'none');
        }

        let interval = setInterval(() => {
            if ($(".cart__gwp-item").find('.cart__row .grid__item.medium-up--three-fifths .grid__item.three-quarters label').length > 0) {
                clearInterval(interval);

                let colors = $(".cart__gwp-item").find('.cart__row .grid__item.medium-up--three-fifths .grid__item.three-quarters label.color');
                let sizeText = $(".cart__gwp-item").find('.cart__row .grid__item.medium-up--three-fifths .grid__item.three-quarters label:not(.color)').eq(0).text();

                colors.each(function () {
                    $(this).css('display', 'inline-block');
                });

                colors.each(function () {
                    let colorText = $(this).data('color');
                    let current = $(this);

                    window.gwpVariants.forEach((variant) => {
                        if (variant.option1 == sizeText && variant.option2 == colorText && variant.available == false) {
                            console.log(variant, 'variant');

                            current.css('display', 'none');
                        }
                    });
                });

                $(".cart__gwp-item").find('.cart__row .grid__item.medium-up--three-fifths .grid__item.three-quarters label:not(.color)').each(function () {
                    $(this).on('click', function (e) {
                        let sizeText = $(e.target).text();

                        colors.each(function () {
                            $(this).css('display', 'inline-block');
                        });

                        $('.unava-colors').remove();

                        colors.each(function () {
                            let colorText = $(this).data('color');
                            let current = $(this);

                            window.gwpVariants.forEach((variant) => {
                                if (variant.option1 == sizeText && variant.option2 == colorText && variant.available == false) {
                                    console.log(variant, 'variant');

                                    current.css('display', 'none');
                                }
                            });
                        });

                        if ($("label.color").is(":visible") == false) {
                            $(".cart__gwp-item").find('.cart__row .grid__item.medium-up--three-fifths .grid__item.three-quarters label.color').eq(0).after( "<p class='unava-colors'>No available colors in this size</p>" );
                        }
                    });
                });
            }
        }, 500);

        // discount
        if (cart.total_discount > 0) {
            $('.discount-wrap').addClass('active')
            $('.discount-wrap .cart__discount').text(`${theme.Currency.formatMoney(cart.total_discount, theme.settings.moneyFormat)} (-${theme.Currency.formatMoney(cart.total_discount, theme.settings.moneyFormat)})`)

        } else {
            $('.discount-wrap').removeClass('active')
        }

    })
}

function renderGwpElem(item, prop) {
    var html =
        `<div class="cart__row cart__row-${prop.variant_id}">` +
        '<div class="grid grid--full cart__row--table-large">' +
        '<div class="grid__item medium-up--three-fifths">' +
        '<div class="grid__item one-quarter">' +
        `<a href="javascript:void(0);"><img src="${item.image.src}" alt="${item.title}"></a>` +
        '</div>' +
        '<div class="grid__item three-quarters">' +
        `<a href="javascript:void(0);" class="h4 cart__product-name navigable">${item.title}</a>`

    item.options.forEach(function (opt) {

        if (opt.name != 'Title') {
            html += `<p>${opt.name}</p>`;

            var name = opt.name.toLowerCase();

            opt.values.forEach(function (v, index) {
                var checked = prop.title.includes(v) ? 'checked' : ''

                if (name == 'color' || name == 'colour') {
                    html += `<input class="hidden" type="radio" name="${opt.name}" id="product-select-${v}" value="${v}" ${checked} onchange="changeGwpVariant()"><label class="color" for="product-select-${v}" data-color="${v}" style="background-image: url(https://cdn.shopify.com/s/files/1/0205/3478/8160/t/61/assets/${v.toLowerCase()}_50x.png); background-color: ${v.toLowerCase()};"></label>`
                } else {
                    html += `<input class="hidden" type="radio" name="${opt.name}" id="product-select-${v}" value="${v}" ${checked} onchange="changeGwpVariant()"><label for="product-select-${v}">${v}</label>`
                }
            })
        }
    });

    html += '<select class="hidden gwp-select-variants">'
    item.variants.forEach(function (opt) {
        var selected = opt.id == prop.variant_id ? 'selected' : ''
        html += `<option value="${opt.id}" data-title="${opt.title}" ${selected}>${opt.title}</option>`
    })
    html += `</select>`

    html +=
        '</div>' +
        '</div>' +
        '<div class="grid__item medium-up--two-fifths">' +
        '<div class="grid grid--full cart__row--table-large">' +
        `<div class="grid__item one-third medium-up--text-right"><span class="cart__price"></span></div>` +
        `<div class="grid__item one-third text-center"></div>` +
        `<div class="grid__item one-third text-right"><span class="cart__price cart__item-total">Free</span></div>` +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>'

    return html
}

function renderCartElem(item) {
    let childProductClass = '';
    let dataChild = '';
    if (item.properties && item.properties._parentProduct !== undefined){
        childProductClass = 'm-hide item-child m-has-parent-product';
        dataChild = `data-child="${item.properties._parentProduct}-${item.variant_id}"`;
    }
    var html =
        `<div class="cart__row cart__row-${item.variant_id} ${childProductClass}" ${dataChild}>` +
        '<div class="grid grid--full cart__row--table-large">' +
        '<div class="grid__item medium-up--three-fifths">' +
        '<div class="grid__item one-quarter">' +
        `<a href="${item.url}"><img src="${item.image}" alt="${item.title}"></a>` +
        '</div>' +
        '<div class="grid__item three-quarters">' +
        `<a href="${item.url}" class="h4 cart__product-name navigable">${item.title.split('-')[0]}</a>` +
        `<p class="cart__product-meta" data-open-accessibility-text-original="15px" style="font-size: 15px;">${item.title.split('-')[1] ? item.title.split('-')[1] : ''}</p>` +
        '<div class="cart__product-meta mobile__quantity">' +
        `<div><input type="number" class="cart__product-qty" data-id="${item.variant_id}" value="${item.quantity}" onchange="changeQuantity(this)"></div>` +
        '</div>' +
        '<p class="cart__product-meta remove">' +
        `<span class="btn btn--secondary btn--small" data-id="${item.variant_id}" onclick="removeItem(${item.variant_id})">remove</span>` +
        '</p>' +
        '</div>' +
        '</div>' +
        '<div class="grid__item medium-up--two-fifths">' +
        '<div class="grid grid--full cart__row--table-large">' +
        `<div class="grid__item one-third medium-up--text-right"><span class="cart__price">${theme.Currency.formatMoney((item.price), theme.settings.moneyFormat)}</span></div>` +
        `<div class="grid__item one-third text-center desktop__quantity"><input type="number" class="cart__product-qty" data-id="${item.variant_id}" value="${item.quantity}" onchange="changeQuantity(this)"></div>` +
        `<div class="grid__item one-third text-right"><span class="cart__price cart__item-total">${theme.Currency.formatMoney((item.quantity * item.price), theme.settings.moneyFormat)}</span></div>` +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>'

    return html
}

function initGwp(cart) {
    if (gwp.enable && gwp.variantId) {
        var id = $('.gwp-select-variants').val() || gwp.variantId

        if (cart.items.length == 1 && cart.items[0].variant_id == id) {
            removeItem(id)
        }

        if (cart.total_price >= gwp.amount && !cart.items.filter(e => e.variant_id == id).length > 0) {
            let flag = true;

            $.ajax({
                type: "GET",
                url: "/cart.js",
                async: false,
                dataType: "json",
                success: function (cart) {
                    let items = cart.items;

                    items.forEach((item) => {
                        if (item.handle == gwp.handle) {
                            flag = false;
                        }
                    });
                }
            });

            if (flag) {
                $.ajax({
                    type: "POST",
                    url: '/cart/update.js',
                    dataType: 'json',
                    async: false,
                    data: {
                        updates: {
                            [`${gwp.variantId}`]: 0
                        }
                    }
                });

                if (window.globalGWPFlag) {
                    addGWPToCart(id)
                }
            }
        }

        if (cart.total_price < gwp.amount && cart.items.filter(e => e.variant_id == id).length > 0) {
            removeItem(id)
        }

        if (cart.items.filter(e => e.variant_id == id).length > 0 && !$('.gwp-select-variants').length) {
            //console.log('gwp', gwp);
            jQuery.getJSON(`/products/${gwp.handle}.json`, function (item) {
                window.prd = item.product;
                cart.items.filter(function (e) {
                    if (e.handle == gwp.handle) {
                        $(".cart__gwp-item").append(renderGwpElem(item.product, e));
                    }
                });
            });
        }
    }
}

window.bottleInterval = setInterval(() => {
    fetch("/cart.js")
        .then(cart => cart.json())
        .then(cart => {
            let flag = false;

            cart.items.forEach(product => {
                if (product.id == '40429407272996') {
                    flag = true;
                }
            });

            initGwp(cart);

            if (cart.total_price > 14900 && !flag) {
                setTimeout(() => {
                    // $('body').trigger('added.ajaxProduct');
                }, 600);
            } else if (cart.total_price < 15000 && flag) {
                setTimeout(() => {
                    // $('body').trigger('added.ajaxProduct');
                }, 600);
            }
        });
}, 3000);

window.globalGWPFlag = true;

document.addEventListener('DOMContentLoaded', function () {
    setInterval(() => {
        if (document.querySelector('.ajaxcart__product[data-variant="40429407272996"] .removeAjaxCartIcon:not(.rendered-icon)')) {
            document.querySelector('.ajaxcart__product[data-variant="40429407272996"] .removeAjaxCartIcon').classList.add('rendered-icon');

            document.querySelector('.ajaxcart__product[data-variant="40429407272996"] .removeAjaxCartIcon.rendered-icon').addEventListener('click', function (e) {
                console.log('GWP delete click');

                window.globalGWPFlag = false;
                gwp.enable = false;
                clearInterval(window.bottleInterval);

                setTimeout(() => {
                    $.ajax({
                        type: "POST",
                        url: '/cart/update.js',
                        dataType: 'json',
                        async: false,
                        data: {
                            updates: {
                                [`${gwp.variantId}`]: 0
                            }
                        },
                        success: function (res) {
                            $('body').trigger('added.ajaxProduct');
                        }
                    });
                }, 1000);
            });
        }
    }, 1000);
});

function changeGwpVariant() {
    var selectedId = $('.gwp-select-variants').val()
    var title

    $('.cart__gwp-item input[type=radio]:checked').each(function (i) {
        var input = $('.cart__gwp-item input[type=radio]:checked').eq(i)
        i == 0 ? title = $(input).val() : title += ` / ${$(input).val()}`
    })

    var newId = $(`.gwp-select-variants option[data-title="${title}"]`).val()
    $('.gwp-select-variants').val(newId)

    removeItem(selectedId, true).then(addGWPToCart(newId, true))
    $('.gwp-select-variants').closest('.cart__row').removeClass(`cart__row-${selectedId}`)
    $('.gwp-select-variants').closest('.cart__row').addClass(`cart__row-${newId}`)

}

function addGWPToCart(id, bool) {
    jQuery.getJSON(`/products/${gwp.handle}.json`, function (item) {
        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            async: false,
            data: {
                updates: {
                    [id]: 1
                }
            },
            dataType: 'json',
            success: function (cart) {
                // var v = item.product.variants.filter(v => v.id == id);
                // var i = item.product.images.filter(i => i.id == v[0].image_id)

                // $('.cart__gwp-item img').attr("src", `${i[0].src}`);

                if (bool) {
                    return
                }

                cart.items.filter(function (e) {
                    if (e.handle == gwp.handle) {
                        if (!$('.gwp-select-variants').length) {
                            $(".cart__gwp-item").append(renderGwpElem(item.product, e))
                        }
                    }
                })
              $('body').trigger('added.ajaxProduct');
            }
        })
    })
}


async function removeItem(id, bool) {
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
            updates: {
                [id]: 0
            }
        },
        dataType: 'json',
        success: function (cart) {
            updateTotals(cart);

            if (bool) {
                return
            }

            if (!cart.items.filter(e => e.variant_id == id).length > 0) {
                $(`.cart__row-${id}`).remove()
            }

            if (gwp.enable && gwp.variantId) {
                initGwp(cart)
            }

            let items = cart.items;
            let counter = 0;
            let additional = [];

            items.forEach((item) => {
                if (item.product_id == '6701166788644') {
                    counter++;

                    additional.push(item);
                }
            });

            if (counter > 1) {
                console.log(additional[0].id);
                console.log('its inside, so 2 products');

                $.ajax({
                    type: "POST",
                    url: '/cart/update.js',
                    dataType: 'json',
                    data: {
                        updates: {
                            [additional[0].id]: 0
                        }
                    }
                });
            }
        },
    })
}


function changeQuantity(item) {
    var id = $(item).data('id')
    var qty = +($(item).val())
    let dataParentTrue = false;
    let child = null;

    let updates = {[id]: qty};

    if($('.cart__row.item-child').length) {
        $('.cart__row.item-child').each(function() {
            let dataChild = $(this).attr('data-child');
            let dataParentId = +(dataChild.split('-')[0]);

            if(String(id) === String(dataParentId)) {
                child = $(this);
                dataParentTrue = true                
            }
        });
    }

    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
            updates: updates
        },
        dataType: 'json',
        success: function (cart) {

            updateTotals(cart)

            if(dataParentTrue) {
                $(child).find('.cart__product-qty').val(qty).trigger('change');
            }

            if (gwp.enable && gwp.variantId) {
                initGwp(cart)
            }

            cart.items.filter(function (e) {

                if (e.variant_id == id) {
                    $(`input[data-id="${id}"]`).closest('.cart__row').find('.cart__item-total').text(theme.Currency.formatMoney(e.original_line_price, theme.settings.moneyFormat))
                }

                if (!cart.items.filter(e => e.variant_id == id).length > 0) {
                    $(`.cart__row-${id}`).remove()
                }
            })
        },
    })
}

function updateTotals(cart) {
    // check for empty cart
    if (cart.item_count > 0) {
        $('.empty__cart').addClass('hidden')
        $('.cart__not-empty').removeClass('hidden')
    } else {
        $('.empty__cart').removeClass('hidden')
        $('.cart__not-empty').addClass('hidden')
    }

    // cart total price
    $('.wh-original-price').text(theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat))

    // cart discount
    if (cart.total_discount > 0) {
        $('.discount-wrap').addClass('active')
        $('.discount-wrap .cart__discount').text(`${theme.Currency.formatMoney(cart.total_discount, theme.settings.moneyFormat)} (-${theme.Currency.formatMoney(cart.total_discount, theme.settings.moneyFormat)})`)

    } else {
        $('.discount-wrap').removeClass('active')
    }

    // afterpay
    $('.afterpay-instalments').text(theme.Currency.formatMoney((cart.total_price / 4), theme.settings.moneyFormat))

}

initAjaxCart()


$(document).on('click', '.ajaxcart__product.item-parent .removeAjaxCartIcon', function() {
    let dataChild = $(this).closest('.ajaxcart__product').attr('data-child');
    let dataChildId = dataChild.split('-')[1];

    function removeCartItemById(variantId) {
        $.get('/cart.js', function(response) {
            let cart = typeof response === 'string' ? JSON.parse(response) : response;
    
            const item = cart.items.find(i => {
                return String(i.variant_id) === String(variantId);
            });
    
            if (item) {
                $.post('/cart/update.js', {
                    updates: {
                        [item.key]: 0
                    }
                }, function(updatedCart) {
                    console.log('Item removed successfully!', updatedCart);
                    $('body').trigger('added.ajaxProduct');
                }).fail(function(error) {
                    console.error('Error updating cart:', error);
                });
            } else {
                console.error('Item with this ID not found in cart');
            }
        }).fail(function(error) {
            console.error('Error fetching cart:', error);
        });
    }
    removeCartItemById(dataChildId);
});


$(document).on('click', '.cart__row.item-parent .cart__product-meta.remove .btn', function() {
    let dataChild = $(this).closest('.cart__row').attr('data-child');

    function observeCartRowRemoval(rowElement, callback) {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                const removedNodes = Array.from(mutation.removedNodes);
                if (removedNodes.some(node => node === rowElement || node.contains(rowElement))) {
                    callback();
                    observer.disconnect();
                }
            });
        });
    
        observer.observe(rowElement.parentNode, { childList: true });
    }
    
    const $cartRow = $(this).closest('.cart__row');
    observeCartRowRemoval($cartRow[0], function() {
        $(`.cart__row.item-child[data-child="${dataChild}"] .cart__product-meta.remove .btn`).trigger('click');
    });
    // setTimeout(function() {
    //     $(`.cart__row.item-child[data-child="${dataChild}"] .cart__product-meta.remove .btn`).trigger('click');
    // },1000);
});

